<template lang="pug">
#section2.pt-5
  #Map
    #cesiumContainer
      #toolbar
        button.mr-1(@click="resetView()")
          img(src="/assets/update-arrow.png")
        button(@click="setViewMode()")
          span(v-if="scene2D == false") 2D
          span(v-if="scene2D == true") 3D
    .container
      .row.justify-content-center.pt-5.pb-5
        //- a.btn.btn-link(href="#section3", role="button")
        //-   img.down(src="/assets/down.svg")
</template>
<script>
//window.CESIUM_BASE_URL = '/';
//import * as Cesium from 'cesium';
//import "cesium/Build/Cesium/Widgets/widgets.css";

export default {
  name: "memorial",
  data() {
    return {
      scene2D: true,
      viewer: {},
      windowWidth: window.innerWidth,
      averageLat: 0,
      averageLong: 0,
      height: 0,
      scale: 0.8,
      labelHeight: 9800,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 767;
    },
  },
  methods: {
    initMap() {
      Cesium.Ion.defaultAccessToken =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIzNzYyNWVhZi0xOGUxLTRkMGEtOTAzZi04OGVmNzI1OGQ3YzciLCJpZCI6MTU0MjIsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1Njc3OTE3MzF9.DoKICAK8YNXF6usQqKliMCoNI5YyAZFgdhYnHVlgeps";

      let viewer = (this.viewer = new Cesium.Viewer("cesiumContainer", {
        animation: false,
        baseLayerPicker: false,
        navigationHelpButton: false,
        sceneModePicker: false,
        homeButton: false,
        geocoder: false,
        fullscreenButton: false,
        timeline: false,
        terrainExaggeration: 2.0,
        selectionIndicator: false,

        imageryProvider: Cesium.createWorldImagery({
          style: Cesium.IonWorldImageryStyle.AERIAL_WITH_LABELS,
        }),

        terrainProvider: new Cesium.CesiumTerrainProvider({
          url:
            "https://api.maptiler.com/tiles/terrain-quantized-mesh/?key=rn1mJz0EpUrA9X7KS6fT",
          credit: new Cesium.Credit(
            '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',
            true
          ),
          requestVertexNormals: true,
        }),
      }));
      let scratchRectangle = new Cesium.Rectangle();
      this.viewer.clock.onTick.addEventListener(() => {
        var rect = this.viewer.camera.computeViewRectangle(
          this.viewer.scene.globe.ellipsoid,
          scratchRectangle
        );
        this.averageLat =
          (Cesium.Math.toDegrees(rect.south) +
            Cesium.Math.toDegrees(rect.north)) /
          2;
        this.averageLong =
          (Cesium.Math.toDegrees(rect.east) +
            Cesium.Math.toDegrees(rect.west)) /
          2;
        this.height = this.viewer.camera.getMagnitude() * 0.001;
        //console.log(this.height, this.averageLat, this.averageLong);
      });

      this.scale = this.isMobile ? 0.4 : 0.8;
      this.labelHeight = this.isMobile ? 13000 : 10370;
      this.addMarkers(this.scale, this.labelHeight);
      this.cameraControls();
    },
    cameraControls() {
      let viewer = this.viewer;
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = 300;
      viewer.scene.screenSpaceCameraController.maximumZoomDistance = 500000;
      viewer.scene.screenSpaceCameraController._minimumZoomRate = 300;
      viewer.scene.screenSpaceCameraController.enableRotate = true;
      viewer.scene.screenSpaceCameraController.enableTranslate = false;
      viewer.scene.screenSpaceCameraController.enableZoom = true;
      viewer.scene.screenSpaceCameraController.enableTilt = false;
      viewer.scene.screenSpaceCameraController.enableLook = false;
      viewer.scene.screenSpaceCameraController.inertiaSpin = 0;
      viewer.scene.screenSpaceCameraController.inertiaZoom = 0;
      viewer.scene.screenSpaceCameraController.maximumMovementRatio = 0.05;
    },
    initialLocation() {
      let initialView = Cesium.Rectangle.fromDegrees(
        -101.0,
        16.35,
        -98.47,
        18.37
      );
      Cesium.Camera.DEFAULT_VIEW_RECTANGLE = initialView;
      Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;
      this.viewer.camera.flyTo({
        destination: initialView,
      });
    },
    set3DView() {
      let viewer = this.viewer;
      let initialPosition = new Cesium.Cartesian3.fromDegrees(
        -100.39,
        16.83,
        10000
      );
      let initialOrientation = new Cesium.HeadingPitchRoll.fromDegrees(
        19.1077496389876024807,
        -10.987223091598949054,
        0.025883251314954971306
      );
      let cameraView = {
        destination: initialPosition,
        orientation: {
          heading: initialOrientation.heading,
          pitch: Cesium.Math.toRadians(-12.0),
          roll: initialOrientation.roll,
        },
      };
      // viewer.scene.preRender.addEventListener(function() {
      //   viewer.camera.setView({
      //       orientation: {
      //           heading: initialOrientation.heading,
      //           pitch: Cesium.Math.toRadians(-12.0),
      //           roll: initialOrientation.roll
      //       }
      //   });
      //});
      viewer.camera.changed.addEventListener(function () {
        if (
          viewer.camera._suspendTerrainAdjustment &&
          viewer.scene.mode === Cesium.SceneMode.SCENE3D
        ) {
          viewer.camera._suspendTerrainAdjustment = false;
          viewer.camera._adjustHeightForTerrain();
        }
      });
      viewer.scene.camera.flyTo(cameraView);
    },
    changeViewTo3D() {
      let scale = this.isMobile ? 0.4 : 0.8;
      let viewer = this.viewer;

      let heading = Cesium.Math.toRadians(50.0);
      let pitch = Cesium.Math.toRadians(-20.0);
      let range = 0;

      if (this.height >= 6650) {
        this.set3DView();
      } else {
        this.height < 6440 ? (range = 5000) : (range = this.height + 30000);
        viewer.camera.lookAt(
          new Cesium.Cartesian3.fromDegrees(this.averageLong, this.averageLat),
          new Cesium.HeadingPitchRange(heading, pitch, range)
        );
        viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      }
    },
    setViewMode() {
      if (this.scene2D == true) {
        this.changeViewTo3D();
      } else {
        this.initialLocation();
      }
      this.scene2D = !this.scene2D;
    },
    resetView() {
      if (this.scene2D == true) {
        this.initialLocation();
      } else {
        this.set3DView();
      }
    },
    addMarkers(scale, labelHeight) {
      let viewer = this.viewer;
      viewer.entities.removeAll();
      viewer.dataSources.removeAll();

      let dataPromise = Cesium.GeoJsonDataSource.load("/data/test.json");
      dataPromise.then(function (dataSource) {
        viewer.dataSources.add(dataSource);
        //get entities
        let entities = dataSource.entities.values;

        for (let i = 0; i < entities.length; i++) {
          let entity = entities[i];

          if (Cesium.defined(entity.billboard)) {
            entity.billboard.image =
              "/assets/" + entity.properties.victim_marker;
            entity.billboard.scale = scale;
            entity.billboard.heightReference =
              Cesium.HeightReference.CLAMP_TO_GROUND;

            let cartographicPosition = Cesium.Cartographic.fromCartesian(
              entity.position.getValue(Cesium.JulianDate.now())
            );
            let lat = Cesium.Math.toDegrees(cartographicPosition.latitude);
            let long = Cesium.Math.toDegrees(cartographicPosition.longitude);

            entity.name = "";
            entity.description = `<div class="container">
              <img src="/assets/${
                entity.properties.victim_photo
              }" class="popup-photo" min-height="200px" width="100%">
              <div class="row">
                <div class="column" style="margin: 0 1rem;">
                  <h1 class="victim-name" style="font-weight:bolder; text-shadow: 1px 0 #fff; letter-spacing:1px; font-size: 2rem; margin:1rem 0 0 0; text-align: center;">${
                    entity.properties.victim_name
                  }</h1>
                  <p class="victim-date" style=" color: #999944; font-weight:500; font-size: 0.8rem; margin: 0; text-align: center;">${
                    entity.properties.init_date
                  } - ${entity.properties.end_date}</p>
                  <p class="coordinate" style=" color: #fff; font-weight:lighter; font-size: 0.8rem; margin: 0; text-align: center;"> Coordenadas: ${long.toFixed(
                    5
                  )} ${lat.toFixed(5)} </p>
                  <p class="text" style=" color: #fff; font-size: 1rem; text-align: justify;">${
                    entity.properties.text
                  } </p>
                </div>
              </div>
            </div>`;

            entity.label = new Cesium.LabelGraphics({
              text: entity.properties.victim_name,
              font: "18px Montserrat",
              style: Cesium.LabelStyle.FILL_AND_OUTLINE,
              outlineWidth: 5,
              pixelOffset: new Cesium.Cartesian2(0, 12),
              scale: scale,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              show: true,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
                0,
                45000
              ),
            });
          }
        }
      });

      viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(
        Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
      );
      //viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.WHEEL);

      viewer.screenSpaceEventHandler.setInputAction(function (e) {
        let picked = viewer.scene.pick(e.position);
        if (Cesium.defined(picked)) {
          let id = Cesium.defaultValue(picked.id, picked.primitive.id);
          if (id instanceof Cesium.Entity) {
            let entity = id;
            if (Cesium.defined(entity)) {
              viewer.flyTo(entity);
            }
          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

      this.addLabel(scale, labelHeight);
    },
    addLabel(scale, labelHeight) {
      let viewer = this.viewer;
      let entity = viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(-100.31, 17.06, labelHeight),
        label: {
          text:
            "Lorem ipsum dolor sit amet, onsectetur adipiscing elit,\n sed do eiusmod tempor incididunt ut labore et dolore magna.",
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0,
            100000
          ),
        },
      });

      entity.label.scale = scale;
    },
  },
  mounted() {
    this.initMap();
    this.initialLocation();
  },
};
</script>

<style lang="scss">
#Map {
  #cesiumContainer {
    position: relative;
    width: 100%;
    height: 78vh;
    margin-top: 3rem;
    padding: 0;
    overflow: hidden;
    #toolbar {
      position: absolute;
      bottom: 5px;
      right: 5px;
      z-index: 1;
      button {
        background-color: #fff;
        color: #000;
        border-radius: 5px;
        border: 2px solid #000;
        padding: 5px;
        width: 40px;
        height: 40px;
        img {
          width: 25px;
          height: auto;
        }
      }
      button:hover {
        //color: #fff;
        background-color: #999943;
        border: 2px solid #000;
      }
    }
  }
  .cesium-infoBox {
    width: 100%;
    height: 100%;
    top: 0px;
    border-radius: 0;
    border: none;
    background: rgba(black, 0.8);
    z-index: 15;
  }
  .cesium-infoBox-title {
    border-radius: 0;
    background: transparent;
    height: 2.5rem;
  }
  button.cesium-infoBox-camera {
    display: none;
  }
  button.cesium-infoBox-close {
    color: transparent;
    font-weight: 200;
    font-size: 2.5rem;
    text-transform: uppercase;
    height: 2.5rem;
    width: 2.5rem;
    background: url("/assets/cancel.png");
    background-size: contain;
    margin: 0.7rem 14px 0 0;
  }
  iframe.cesium-infoBox-iframe {
    max-height: 68vh !important;
    height: 68vh !important;
    margin: 1rem auto;
  }
  .cesium-infoBox-defaultTable {
    display: none;
  }
}
</style>
